import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import { AuthProvider } from "./components/mensag/AuthProvider";
import { MensagLayout } from "./components/mensag/MensagLayout";

import ChatsPage from "./pages/mensag/ChatsPage";
import ChatPage from "./pages/mensag/ChatPage";
import ProfilePage from "./pages/mensag/ProfilePage";
import SettingsPage from "./pages/mensag/SettingsPage";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <Routes>
          {/* MensaG Routes */}
          <Route path="/" element={<MensagLayout />}>
            <Route index element={<ChatsPage />} />
            <Route path="chat/:contactId" element={<ChatPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>

          {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
          <Route path="/:nip19" element={<NIP19Page />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
export default AppRouter;